// extracted by mini-css-extract-plugin
export default {"note":"styles_note__j4mWc","icon":"styles_icon__AURwq"};